/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_i4_105_52(e) {
  return (
    <li
      key={e.clave}
      className={`inline-flex items-center gap-1.5`}
      children={[
        <span
          aria-hidden={`true`}
          className={`h-3 w-1.5 rounded-full`}
          style={{
            background: e.color,
          }}
        />,
        e.nombre,
      ]}
    />
  );
}
